import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_LIST_ITEMS_START, POST_LIST_ITEMS_ERROR, POST_LIST_ITEMS_START, POST_LIST_ITEMS_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/list-items/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: POST_LIST_ITEMS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: POST_LIST_ITEMS_ERROR, error });
  } finally {
    yield put({ type: GET_LIST_ITEMS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1)
  }
}

export default function* post_list_items() {
  yield takeLatest(POST_LIST_ITEMS_START, create);
}
